import { Button, ButtonTheme } from '@cian/button-component';
import { RadioGroupField } from '@cian/components';
import * as React from 'react';
import * as Modal from 'react-modal';

import { IChangePrintOptions } from '../../../store/popups/print';
import { IconClose } from '../../subscription_price_changes_popup/icons/icon_close';
import * as styles from './index.css';
import { trackPrint } from './tracking';

export interface IPrintModalProps {
  isCommentsVisible: boolean;
  isOpen: boolean;
  isPhonesVisible: boolean;
  isPrintModeEnabled: boolean;

  changePrintOptions(options: IChangePrintOptions): void;
  toggle(isOpen?: boolean): void;
}

const printPhonesValues = [
  {
    label: 'С телефонами',
    value: 1,
  },
  {
    label: 'Без телефонов',
    value: 0,
  },
];

const printCommentValues = [
  {
    label: 'С комментарием',
    value: 1,
  },
  {
    label: 'Без комментария',
    value: 0,
  },
];

export class PrintModal extends React.PureComponent<IPrintModalProps, {}> {
  public componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  public componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  public render() {
    let overlay = {};

    if (this.props.isPrintModeEnabled) {
      overlay = {
        display: 'none',
      };
    } else {
      overlay = {
        alignItems: 'center',
        backgroundColor: 'rgba(24, 41, 48, .8)',
        display: 'flex',
        justifyContent: 'center',
        zIndex: 10000,
      };
    }

    return (
      <Modal
        isOpen={this.props.isOpen}
        ariaHideApp={false}
        onRequestClose={this.close}
        style={{
          content: {
            backgroundColor: 'white',
            borderRadius: '4px',
            boxShadow: '0 2px 16px 0 rgba(0, 0, 0, 0.22)',
            overflow: 'visible',
            padding: '24px 30px 40px',
            position: 'relative',
            width: '500px',
            zIndex: 10001,
          },
          overlay,
        }}
      >
        <button className={styles['close']} onClick={this.close}>
          <IconClose />
        </button>
        <h3 className={styles['title']}>Распечатать объявление</h3>
        <form onSubmit={this.handleSubmit} className={styles['form']}>
          <RadioGroupField
            containerStyle={styles['options']}
            value={Number(this.props.isPhonesVisible)}
            onValueChange={this.handlePrintPhonesChange}
            values={printPhonesValues}
          />
          <RadioGroupField
            containerStyle={styles['options']}
            value={Number(this.props.isCommentsVisible)}
            onValueChange={this.handlePrintCommentsChange}
            values={printCommentValues}
          />
          <div className={styles['actions']}>
            <Button onClick={trackPrint}>
              Распечатать
            </Button>
            <Button onClick={this.handleClickOnCloseButton} theme={ButtonTheme.Ghost}>
              Отменить
            </Button>
          </div>
        </form>
      </Modal>
    );
  }

  private handleClickOnCloseButton = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    this.close();
  }

  private close = () => {
    this.props.toggle(false);
  }

  private handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    this.props.changePrintOptions({
      isPrintModeEnabled: true,
    });

    setTimeout(() => {
      window.print();
      this.props.changePrintOptions({
        isPrintModeEnabled: false,
      });
      this.close();
    }, 500);
  }

  private handlePrintPhonesChange = (isPhonesVisible: number) => {
    this.props.changePrintOptions({
      isPhonesVisible: isPhonesVisible === 1,
    });
  }

  private handlePrintCommentsChange = (isCommentsVisible: number) => {
    this.props.changePrintOptions({
      isCommentsVisible: isCommentsVisible === 1,
    });
  }

  private handleKeyDown = (e: KeyboardEvent) => {
    const KEY_CODE_P = 80;
    if (e.keyCode === KEY_CODE_P && (e.ctrlKey || e.metaKey)) {
      e.preventDefault();
      this.props.toggle(true);
    }
  }
}
